export default "__VITE_ASSET__7$RsOp26__"